<!--=====================================
=            PRODUCT DETAILS            =
======================================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Product Detail</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Product Details</div>
          <div slot="card-body">
            <div class="row">
              <div class="col-xl-6">
                <div class="product-detai-imgs">
                  <div class="row">
                    <div class="col-md-2 col-3">
                      <div
                        class="nav flex-column nav-pills"
                        id="v-pills-tab"
                        role="tablist"
                        aria-orientation="vertical"
                      >
                        <a
                          class="nav-link active"
                          id="product-1-tab"
                          data-toggle="pill"
                          href="#product-1"
                          role="tab"
                          aria-controls="product-1"
                          aria-selected="true"
                        >
                          <img
                            src="../../assets/img/product/img-7.png"
                            alt
                            class="img-fluid mx-auto d-block rounded"
                          />
                        </a>
                        <a
                          class="nav-link"
                          id="product-2-tab"
                          data-toggle="pill"
                          href="#product-2"
                          role="tab"
                          aria-controls="product-2"
                          aria-selected="false"
                        >
                          <img
                            src="../../assets/img/product/img-8.png"
                            alt
                            class="img-fluid mx-auto d-block rounded"
                          />
                        </a>
                        <a
                          class="nav-link"
                          id="product-3-tab"
                          data-toggle="pill"
                          href="#product-3"
                          role="tab"
                          aria-controls="product-3"
                          aria-selected="false"
                        >
                          <img
                            src="../../assets/img/product/img-7.png"
                            alt
                            class="img-fluid mx-auto d-block rounded"
                          />
                        </a>
                        <a
                          class="nav-link"
                          id="product-4-tab"
                          data-toggle="pill"
                          href="#product-4"
                          role="tab"
                          aria-controls="product-4"
                          aria-selected="false"
                        >
                          <img
                            src="../../assets/img/product/img-8.png"
                            alt
                            class="img-fluid mx-auto d-block rounded"
                          />
                        </a>
                      </div>
                    </div>
                    <div class="col-md-7 offset-md-1 col-9">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="product-1"
                          role="tabpanel"
                          aria-labelledby="product-1-tab"
                        >
                          <div>
                            <img
                              src="../../assets/img/product/img-7.png"
                              alt
                              class="img-fluid mx-auto d-block"
                            />
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="product-2"
                          role="tabpanel"
                          aria-labelledby="product-2-tab"
                        >
                          <div>
                            <img
                              src="../../assets/img/product/img-8.png"
                              alt
                              class="img-fluid mx-auto d-block"
                            />
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="product-3"
                          role="tabpanel"
                          aria-labelledby="product-3-tab"
                        >
                          <div>
                            <img
                              src="../../assets/img/product/img-7.png"
                              alt
                              class="img-fluid mx-auto d-block"
                            />
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="product-4"
                          role="tabpanel"
                          aria-labelledby="product-4-tab"
                        >
                          <div>
                            <img
                              src="../../assets/img/product/img-8.png"
                              alt
                              class="img-fluid mx-auto d-block"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center">
                        <button
                          type="button"
                          class="btn btn-primary waves-effect waves-light mt-2 mr-1"
                        >
                          <i class="bx bx-cart mr-2"></i> Add to cart
                        </button>
                        <button type="button" class="btn btn-success waves-effect mt-2 waves-light">
                          <i class="bx bx-shopping-bag mr-2"></i>Buy now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="mt-4 mt-xl-3">
                  <a href="#" class="text-primary">Headphone</a>
                  <h4 class="mt-1 mb-3">Wireless Headphone (Black)</h4>
                  <p class="text-muted float-left mr-3">
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star"></span>
                  </p>
                  <p class="text-muted mb-4">( 152 Customers Review )</p>
                  <h6 class="text-success text-uppercase">20 % Off</h6>
                  <h5 class="mb-4">
                    Price :
                    <span class="text-muted mr-2">
                      <del>
                        $240
                        USD
                      </del>
                    </span>
                    <b>$225 USD</b>
                  </h5>
                  <p class="text-muted mb-4">
                    To achieve this, it would be necessary to have
                    uniform grammar pronunciation and more common words If several
                    languages
                    coalesce
                  </p>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div>
                        <p class="text-muted">
                          <i class="bx bx-unlink font-size-16 align-middle text-primary mr-1"></i>
                          Wireless
                        </p>
                        <p class="text-muted">
                          <i
                            class="bx bx-shape-triangle font-size-16 align-middle text-primary mr-1"
                          ></i>
                          Wireless Range : 10m
                        </p>
                        <p class="text-muted">
                          <i class="bx bx-battery font-size-16 align-middle text-primary mr-1"></i>
                          Battery life : 6hrs
                        </p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div>
                        <p class="text-muted">
                          <i class="bx bx-user-voice font-size-16 align-middle text-primary mr-1"></i>
                          Bass
                        </p>
                        <p class="text-muted">
                          <i class="bx bx-cog font-size-16 align-middle text-primary mr-1"></i>
                          Warranty : 1 Year
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="product-color">
                    <h5 class="font-size-15">Color :</h5>
                    <a href="#" class="active">
                      <div class="product-color-item border rounded">
                        <img src="../../assets/img/product/img-7.png" alt class="avatar-md" />
                      </div>
                      <p>Black</p>
                    </a>
                    <a href="#">
                      <div class="product-color-item border rounded">
                        <img src="../../assets/img/product/img-7.png" alt class="avatar-md" />
                      </div>
                      <p>Blue</p>
                    </a>
                    <a href="#">
                      <div class="product-color-item border rounded">
                        <img src="../../assets/img/product/img-7.png" alt class="avatar-md" />
                      </div>
                      <p>Gray</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->
            <div class="mt-5">
              <h5 class="mb-3">Specifications :</h5>
              <div class="table-responsive">
                <table class="table mb-0 table-bordered">
                  <tbody>
                    <tr>
                      <th scope="row" style="width: 400px;">Category</th>
                      <td>Headphone</td>
                    </tr>
                    <tr>
                      <th scope="row">Brand</th>
                      <td>JBL</td>
                    </tr>
                    <tr>
                      <th scope="row">Color</th>
                      <td>Black</td>
                    </tr>
                    <tr>
                      <th scope="row">Connectivity</th>
                      <td>Bluetooth</td>
                    </tr>
                    <tr>
                      <th scope="row">Warranty Summary</th>
                      <td>1 Year</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- end Specifications -->
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="4">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div class="row align-items-center">
              <div class="col-md-4">
                <img
                  src="../../assets/img/product/img-7.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
              <div class="col-md-8">
                <div class="text-center text-md-left pt-3 pt-md-0">
                  <h5 class="mb-3 text-truncate">
                    <a href="#" class="text-dark">Wirless Headphone</a>
                  </h5>
                  <p class="text-muted">
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star"></i>
                  </p>
                  <h5 class="my-0">
                    <span class="text-muted mr-2">
                      <del>$240</del>
                    </span>
                    <b>$225</b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div class="row align-items-center">
              <div class="col-md-4">
                <img
                  src="../../assets/img/product/img-4.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
              <div class="col-md-8">
                <div class="text-center text-md-left pt-3 pt-md-0">
                  <h5 class="mb-3 text-truncate">
                    <a href="#" class="text-dark">Phone patterned cases</a>
                  </h5>
                  <p class="text-muted">
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star"></i>
                  </p>
                  <h5 class="my-0">
                    <span class="text-muted mr-2">
                      <del>$150</del>
                    </span>
                    <b>$145</b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div class="row align-items-center">
              <div class="col-md-4">
                <img
                  src="../../assets/img/product/img-6.png"
                  alt
                  class="img-fluid mx-auto d-block"
                />
              </div>
              <div class="col-md-8">
                <div class="text-center text-md-left pt-3 pt-md-0">
                  <h5 class="mb-3 text-truncate">
                    <a href="#" class="text-dark">Phone Dark Patterned cases</a>
                  </h5>
                  <p class="text-muted">
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star text-warning"></i>
                    <i class="bx bx-star"></i>
                  </p>
                  <h5 class="my-0">
                    <span class="text-muted mr-2">
                      <del>$138</del>
                    </span>
                    <b>$135</b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>
<!--====  End of PRODUCT DETAILS  ====-->